var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileupload = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 68 67",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File Upload / Light / Duotone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    opacity: 0.25,
    d: "M8.875 11.1665C8.875 6.54112 12.6246 2.7915 17.25 2.7915H44.4893C46.7105 2.7915 48.8407 3.67387 50.4113 5.24448L56.672 11.5052C58.2426 13.0758 59.125 15.206 59.125 17.4272V55.8332C59.125 60.4585 55.3754 64.2082 50.75 64.2082H17.25C12.6246 64.2082 8.875 60.4585 8.875 55.8332V11.1665Z",
    fill: "#1B84FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M42.375 5.28113C42.375 3.90615 43.4896 2.7915 44.8646 2.7915C46.8455 2.7915 48.7452 3.5784 50.1459 4.97909L56.9374 11.7706C58.3381 13.1713 59.125 15.071 59.125 17.0519C59.125 18.4269 58.0104 19.5415 56.6354 19.5415H45.1667C43.6249 19.5415 42.375 18.2916 42.375 16.7498V5.28113Z",
    fill: "#1B84FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M32.9314 25.3368C32.6022 25.4731 32.2937 25.675 32.026 25.9427L23.651 34.3177C22.5608 35.4079 22.5608 37.1755 23.651 38.2657C24.7412 39.3559 26.5088 39.3559 27.599 38.2657L31.2084 34.6563V47.4583C31.2084 49.0001 32.4582 50.25 34 50.25C35.5418 50.25 36.7917 49.0001 36.7917 47.4583V34.6563L40.401 38.2657C41.4912 39.3559 43.2588 39.3559 44.349 38.2657C45.4393 37.1755 45.4393 35.4079 44.349 34.3177L35.974 25.9427C35.1515 25.1201 33.9433 24.9182 32.9314 25.3368Z",
    fill: "#1B84FF"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileupload);
export default ForwardRef;